import { useEffect } from 'react'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { useQueryClient } from '@tanstack/react-query'

const QueryKeyInvalidator = () => {
  const client = useQueryClient()
  useEffect(() => {
    Object.keys(QueryKeys).forEach((key) => {
      QueryKeys[key].invalidate = (...args) => {
        client.invalidateQueries({ queryKey: QueryKeys[key](...args) })
      }
      QueryKeys[key].invalidateAll = () => {
        client.invalidateQueries({ queryKey: [QueryKeys[key]()[0]] })
      }
    })
  }, [client])

  return null
}

export default QueryKeyInvalidator
